<template>
  <div class="yqPopModel">
    <div class="photoArea">
      <div class="row-item">
        <div class="yq-picture element-list jb-bg">仪器照片</div>
      </div>
      <div class="row-item">
        <div class="yq-img">
          <img :src="particular.photoLink" class="avatar" />
        </div>
      </div>
    </div>
    <div class="wrapper model">
      <div class="row-item element-list">
        <div class="left-item jb-bg">仪器名称：</div>
        <div class="rigth-item text1">
          {{ particular.instrumentName }}
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">仪器设备编号：</div>
        <div class="rigth-item text1">
          {{ particular.serialNumber }}
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">提出人：</div>
        <div class="rigth-item text1">
          {{ particular.proposer }}
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">提出时间：</div>
        <div class="rigth-item text1">
          {{ particular.proPoseTime }}
        </div>
      </div>
      <el-tooltip class="item" effect="dark" :content=" particular.repairContent " >
    <div class="row-item element-list">
      <div class="left-item jb-bg">维修内容：</div>
        <div class="rigth-item text1">
          {{ particular.repairContent }}
        </div>
      </div>
    </el-tooltip>

  
      <div class="row-item element-list">
        <div class="left-item jb-bg">检定时间：</div>
        <div class="rigth-item">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="particular.validityEffectiveTime"
            type="datetime"
            style="width: 174.73px"
            class="date-picker"
            placeholder="选择日期时间"
          >
          </el-date-picker>
          <!-- <el-input v-model="particular.validityEffectiveTime"></el-input> -->
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">准确度：</div>
        <div class="rigth-item">
          <el-input  maxlength="100" v-model="particular.precision"></el-input>
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">不确定度/准确度：</div>
        <div class="rigth-item">
          <el-input  maxlength="100" v-model="particular.accuracy"></el-input>
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">状态：</div>
        <div class="rigth-item">
          <el-select
            :poper-append-to-body="false"
            popper-class="my-select"
            v-model="particular.states"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="my-buttom select-buttom btn" @click="dispose(true)">确认</div>
      <div class="my-buttom btn" @click="dispose(false)">取消</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    message: Object,
  },
  computed: {
  },
  data() {
    return {
      options: [
        {
          value: 0,
          label: "正常",
        },
        {
          value: 1,
          label: "降级",
        },
        {
          value: 2,
          label: "停用",
        },
        {
          value: 3,
          label: "需维修",
        },
        {
          value: 4,
          label: "需检定",
        },
        {
          value: 5,
          label: "需保养",
        },
        {
          value: 6,
          label: "报废",
        },
      ],
      particular: {}
    };
  },
  created() {
    this.particular = JSON.parse(JSON.stringify(this.message))
  },
  methods: {
    dispose(item) {
      let bolVal = item;
      let data = {
        handleTime: this.particular.validityEffectiveTime,
        accuracy: this.particular.accuracy,
        precision: this.particular.precision,
        states: this.particular.states,
        id: this.particular.id,
      };
      if (data.handleTime == "") {
        this.$message({
          message: "请选择检定时间",
          type: "warning",
        });
        return;
      }
      if (data.accuracy == "") {
        this.$message({
          message: "不确定度/准确度不为空",
          type: "warning",
        });
        return;
      }
      if (data.precision == "") {
        this.$message({
          message: "准确度不能空",
          type: "warning",
        });
        return;
      }
      this.$emit("dispose", bolVal, data);
    },
  },
};
</script>

<style lang="less" scopde>
.yqPopModel {
  width: 100%;
  // height: 360px;
  color: #74c8fe;
  // display: flex;
  // white-space: nowrap;
  .photoArea {
    width: 40%;
    float: left;

    .yq-picture {
      width: 178px;
    }
    .yq-img {
      .avatar-uploader .el-upload {
        border: 2px solid#0090F0;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #74c8fe;
        width: 178px;
        height: 178px;
        border: 2px solid#0090F0;
        border-radius: 6px;
        line-height: 178px;
        text-align: center;
      }
      .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }
    }
  }
  .wrapper {
    margin-left: 2%;
    width: 58%;
    float: left;
  }
  .footer {
    clear: both;
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .element-list {
    border: 2px solid #0090f0;
    border-radius: 6px;
    height: 30px;
    line-height: 30px;
    margin: 10px 0;
    text-align: center;
    .left-item {
      width: 130px;
    }
    .rigth-item {
      width: 175px;
      /deep/ .el-upload-list {
        height: 60px;
        overflow: auto;
      }
      /deep/ .el-input__prefix {
        display: none;
      }
      /deep/ .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100% !important;
      }
      /deep/ .el-input__icon {
        line-height: 30px;
      }
      .date-picker {
        .el-input__prefix {
          display: none;
        }
        .el-input__suffix {
          top: -5px;
        }
      }
    }
  }
  .btn {
    width: 150px;
    margin-right: 10px;
    cursor: pointer;
  }
  .text1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .jb-bg {
    background-image: linear-gradient(#0479b4, #02407e);
  }
  .el-input.is-disabled .el-input__inner {
    color: #74c8fe;
    background-color: initial;
    // border: 2px solid #74c8fe;
  }
  .el-input__inner,.el-textarea__inner {
    color: #74c8fe;
    background-color: initial;
    // border: 2px solid #74c8fe;
  }
  .el-form-item__label{
    color: #74c8fe;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/maintenance/components/yqPopModel.vue